// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { pmtApi } from '../apis/pmt.api';

// action
import { actions } from '../actions/pmt.action';

/**
 * PMT History 조회
 */
export const getPmtHistoryList = createAsyncThunk(
  actions.getPmtHistoryListAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await pmtApi.getPmtHistoryList(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * PMT History  조회-벤더용
 */
export const getPmtHistoryListVendor = createAsyncThunk(
  actions.getPmtHistoryListVendorAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await pmtApi.getPmtHistoryListVendor(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * PMT List 조회
 */
export const getPmtList = createAsyncThunk(
  actions.getPmtListAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await pmtApi.getPmtList(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * PMT Save
 */
export const createPmt = createAsyncThunk(
  actions.createPmtAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await pmtApi.createPmt(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
